import React, { useContext } from "react";

import { FormTextInput, FormContainer } from "../../_common";

import { useFormUpdate } from "../../../hooks";
import { Context as AuthContext } from "../../../context/AuthContext";
import { Context as ModalContext } from "../../../context/ModalContext";
import useSchemas from "./form.schema";

const ProfileEditForm = () => {
  const {
    state: { user, errorMessage },
    updateMe
  } = useContext(AuthContext);

  const { closeModal } = useContext(ModalContext);

  const { initialState, validationStateSchema } = useSchemas(user);

  const [
    updatedData,
    handleUpdateData,
    buttonState,
    handleOnSubmit,
    isButtonLoading
  ] = useFormUpdate(initialState, validationStateSchema, cleanData =>
    handleSubmit(cleanData)
  );

  const handleSubmit = async cleanData => {
    try {
      await updateMe(cleanData, () => closeModal());
      throw Error("Error sends to previous error block.");
    } catch {
      throw Error("Error sends to previous error block.");
    }
  };

  return (
    <FormContainer
      handleSubmit={handleOnSubmit}
      buttonState={buttonState}
      isButtonLoading={isButtonLoading}
      errorMessage={errorMessage.message}
    >
      <FormTextInput
        name="email"
        placeholder="Correo"
        value={updatedData.email.value}
        errorValue={updatedData.email.error}
        onChange={handleUpdateData}
      />
      <FormTextInput
        name="password"
        type="password"
        placeholder="Contraseña"
        value={updatedData.password.value}
        errorValue={updatedData.password.error}
        onChange={handleUpdateData}
      />
      <FormTextInput
        name="screen_name"
        placeholder="Nombre"
        value={updatedData.screen_name.value}
        errorValue={updatedData.screen_name.error}
        onChange={handleUpdateData}
      />
      <FormTextInput
        name="ig_profile"
        placeholder="Instagram"
        value={updatedData.ig_profile.value}
        errorValue={updatedData.ig_profile.error}
        onChange={handleUpdateData}
      />
      <FormTextInput
        name="bio"
        placeholder="Bio"
        textArea
        value={updatedData.bio.value}
        errorValue={updatedData.bio.error}
        onChange={handleUpdateData}
      />
    </FormContainer>
  );
};

export default ProfileEditForm;
